export default {
  init() {
    // JavaScript to be fired on the page

  },
  finalize() {
    // JavaScript to be fired on the page, after the init JS
    //Page Menu
		//On toggle fire size calc
		$('#content-body').on('off.zf.toggler', function() {
			console.log('we changed, time to manually resize');
			$('#page-menu').foundation('_calc', true);
			var asideWidth = $('#page-header').width()*.1666667;
			console.log(asideWidth.toString());
			$('#page-menu').css('max-width', asideWidth.toString());		
		});

		$('#aside-navigation').on('resizeme.zf.trigger', function() {
			console.log('We resized this guy');
			$('#page-menu').css('width', '100%');
		});	
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/page.js